import React from "react";
import { Box, Circle, Square, Flex, Text } from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { IStep, TSingleStep } from "./types";
const circleSize = 7;

const white = "white";
const dark = "brand.100";
const gray = "brand.500";

const Step: React.FC<IStep> = (props: IStep) => {
  const { label, children, state, isActive, isCompleted } = props;
  const checkColor = isActive ? white : gray;
  const states = {
    active: {
      color: white,
      bg: dark,
      border: dark,
      label: children,
    },
    complete: {
      color: white,
      bg: dark,
      border: dark,
      label: <CheckIcon color={checkColor} size="12px" />,
    },
    incomplete: {
      color: gray,
      bg: white,
      border: gray,
      label: children,
    },
  };

  return (
    <Box as="li" display="inline-flex" minW="70px">
      <>
        <Square
          aria-hidden
          zIndex={1}
          position="relative"
          size={circleSize}
          bg={states[state].border}
        >
          <Square
            aria-hidden
            zIndex={2}
            position="relative"
            size={circleSize - 1}
            bg={states[state].bg}
          >
            <Box
              as="span"
              color={states[state].color}
              fontWeight="bold"
              fontSize="16px"
            >
              {isCompleted ? states.complete.label : states[state].label}
            </Box>
          </Square>
        </Square>
      </>
      <Flex justifyContent="center" alignItems="center" ml="16px" mr="50px">
        <Text fontSize="16px" color={"black"}>
          {label}
        </Text>
      </Flex>
    </Box>
  );
};

export default Step;
